import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads the records list once the functional usage has been applied, so the
 * table shows the resulting Last Update and Status.
 */
export const reloadRecordsOnSubmitSuccess = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.currentListPlugin.feature.actions.load
            .from(action)
            .create(),
        ),
      ),
)
